/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_TitleInputs */

const zh_usage_title = /** @type {(inputs: Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用量记录`)
};

const en_usage_title = /** @type {(inputs: Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

const es_usage_title = /** @type {(inputs: Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso`)
};

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {Usage_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const usage_title = /** @type {((inputs?: Usage_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_title(inputs)
	if (locale === "en") return en_usage_title(inputs)
	return es_usage_title(inputs)
});